import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InvoicesComponent} from './invoices.component';
import {TableModule} from 'primeng/table';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {CalendarModule} from 'primeng/calendar';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MenuModule} from 'primeng/menu';
import {SplitButtonModule} from 'primeng/splitbutton';
import {SharedModule} from '../@shared';
import {ToastModule} from 'primeng/toast';
import {DialogModule} from 'primeng/dialog';
import {SidebarModule} from 'primeng/sidebar';
import {InvoiceFiltersComponent} from './invoice-filters/invoice-filters.component';
import {MultiSelectModule} from 'primeng/multiselect';
import {PaginatorModule} from 'primeng/paginator';
import {InvoicesCardComponent} from './invoices-card/invoices-card.component';
import {TabViewModule} from 'primeng/tabview';
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {BadgeModule} from "primeng/badge";


@NgModule({
    declarations: [InvoicesComponent, InvoiceFiltersComponent, InvoicesCardComponent],
    exports: [],
    imports: [
        CommonModule,
        TableModule,
        BreadcrumbModule,
        FormsModule,
        InputTextModule,
        CalendarModule,
        RippleModule,
        ReactiveFormsModule,
        ButtonModule,
        PdfViewerModule,
        MenuModule,
        SplitButtonModule,
        SharedModule,
        ToastModule,
        DialogModule,
        SidebarModule,
        MultiSelectModule,
        PaginatorModule,
        TabViewModule,
        ConfirmDialogModule,
        BadgeModule
    ]
})
export class InvoicesModule {
}
